import { z } from 'zod';
import { WIDGET_BLOCK_TYPES } from './blocks/widgets';

/**
 * Wave-1 blocks a paired player declares today. Kept as its own list so
 * `apps/player` can report exactly what it implements without over-claiming the
 * §3 widgets (which are `tablet_only` until their SVG renderer exists).
 */
export const BLOCK_TYPES = ['media', 'text', 'buttons', 'form', 'consent', 'rating', 'live_tile', 'web_embed'] as const;
export const WAVE2_BLOCK_TYPES = ['quiz'] as const;

/** The §3 widget set (re-exported from the shared widget schema file). */
export { WIDGET_BLOCK_TYPES };

/** Every block type the capability contract accepts: wave 1 + §3 widgets. */
export const ALL_BLOCK_TYPES = [...BLOCK_TYPES, ...WIDGET_BLOCK_TYPES] as const;

export const BlockTypeSchema = z.enum(ALL_BLOCK_TYPES);
export type BlockType = z.infer<typeof BlockTypeSchema>;

export const CapabilitiesSchema = z.object({
  device_class: z.enum(['tablet', 'esp32']),
  lockdown: z.enum(['none', 'pwa', 'shell']),
  touch: z.boolean(),
  screen_w: z.number().int().positive(),
  screen_h: z.number().int().positive(),
  blocks: z.array(BlockTypeSchema),
  app_version: z.string().min(1)
});

export type Capabilities = z.infer<typeof CapabilitiesSchema>;
